@if (!isPlaying() && hasBegin()) {
  <app-pause-overlay />
}

@if (videoUrl()) {
  <app-screen-video appDisplayMode [videoUrl]="videoUrl()!" [isCard]="isMiniVideo()" />
}

@if (!dataIsLoaded()) {
  <app-loader-overlay />
} @else {
  @if (isImmerssiveMode() && hasBegin() && isPlaying()) {
    <div class="immerssive-mode">
      <app-icon icon="immersive" [size]="2" />
      <p translate>pages.display.mode.immersive</p>
    </div>
  }

  @if (!isImmerssiveMode() && rankEnabled() && hasBegin() && isPlaying()) {
    <app-rank [players]="players()" />
  }

  @if (!isImmerssiveMode() && datasEnabled() && hasBegin() && isPlaying()) {
    <app-screen-datas [dataBlocks]="dataBlocks()" />
  }

  @if (!isImmerssiveMode() && chartEnabled() && hasBegin() && isPlaying()) {
    <app-screen-chart [trainingSections]="trainingSections()!" />
  }

  @if (
    !isImmerssiveMode() &&
    (miniMapEnabled() || !isMiniMap()) &&
    hasBegin() &&
    isPlaying() &&
    tilesDisplayable()
  ) {
    <app-screen-map
      appDisplayMode
      [isCard]="isMiniMap()"
      [trainingSections]="trainingSections()!"
    />
  }

  @if (!isImmerssiveMode() && resistanceBlockEnabled() && hasBegin() && isPlaying()) {
    <app-resistance />
  }
}
